// Hangar §39.6 (M106.6) — "the timer tells you even when you've tabbed away."
//
// A tiny pure decision, extracted for `tests/hangar-timer.test.ts`'s own sake: `boot.ts`'s
// `onTimerFinished` is deep inside `startGame`'s closure and far too heavy to construct just to
// prove "within radius, bridged, and unfocused" is the whole rule. Pure logic only — no wire
// protocol, no literal — so it carries none of the weight `hangar/**`'s other modules do and is
// imported statically, unlike `invite.ts`.
import type { HangarClient } from './bridge';

/**
 * Whether a COW-4 timer finishing at `distance` from the player should also ring a real Hangar
 * notification, on top of the action-bar line every in-world player already gets regardless.
 *
 * `focused === false` rather than `!focused`: `hangarFocused` is `undefined` outside Hangar
 * (solo, or not yet handshaked), and `undefined` must read as "no reason to think otherwise" —
 * the same instinct that keeps `hangar?.bridged()` the gate rather than `hangar !== undefined`.
 */
export function shouldNotifyTimerFinished(
  distance: number,
  radius: number,
  hangar: HangarClient | undefined,
  focused: boolean | undefined,
): boolean {
  return distance <= radius && Boolean(hangar?.bridged()) && focused === false;
}
